import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Betriebsart } from '../../../../../projects/kiene-core/src/lib/components/stammdaten/vvvo/classes/betriebsart';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { FibuErloesSuffix } from '../fibu-erloes-suffix';

@Component({
    selector: 'kiene-fibu-erloes-suffix-dialog',
    templateUrl: './fibu-erloes-suffix-dialog.component.html',
    styleUrls: ['./fibu-erloes-suffix-dialog.component.scss'],
})
export class FibuErloesSuffixDialogComponent implements OnInit {
    isEdit = false;

    suffixCtrl = new UntypedFormControl('', [Validators.required]);
    bezeichnungCtrl = new UntypedFormControl('', [Validators.required]);
    sortierungCtrl = new UntypedFormControl(0);
    aktivCtrl = new UntypedFormControl(true);

    betriebsart: Betriebsart = null;
    private id: number = null;

    constructor(
        public dialogRef: MatDialogRef<FibuErloesSuffixDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: { row: FibuErloesSuffix },
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        const r = this.data?.row;
        if (r?.fibu_erloes_suffix_id) {
            this.isEdit = true;
            this.id = r.fibu_erloes_suffix_id;
            this.suffixCtrl.setValue(r.suffix);
            this.bezeichnungCtrl.setValue(r.bezeichnung);
            this.sortierungCtrl.setValue(r.sortierung ?? 0);
            this.aktivCtrl.setValue(r.aktiv > 0);
            if (r.betriebsart_id) {
                const b = new Betriebsart();
                b.betriebsart_id = r.betriebsart_id;
                b.bezeichnung = r.betriebsart || '';
                this.betriebsart = b;
            }
        }
    }

    get previewPraxis(): string {
        const s = (this.suffixCtrl.value || '').toString().replace(/^\.+/, '').trim();
        return s ? `8401.${s}` : '8401';
    }

    get previewLabor(): string {
        const s = (this.suffixCtrl.value || '').toString().replace(/^\.+/, '').trim();
        return s ? `8402.${s}` : '8402';
    }

    /** @deprecated use previewPraxis – Spalte beispiel_konto zeigt Praxis */
    get previewKonto(): string {
        return this.previewPraxis;
    }

    setBetriebsart(b: Betriebsart) {
        this.betriebsart = b;
    }

    isValid(): boolean {
        return this.suffixCtrl.valid && this.bezeichnungCtrl.valid;
    }

    save() {
        if (!this.isValid()) {
            return;
        }
        const body: any = {
            suffix: (this.suffixCtrl.value || '').toString().replace(/^\.+/, '').trim(),
            bezeichnung: (this.bezeichnungCtrl.value || '').trim(),
            betriebsart_id: this.betriebsart?.betriebsart_id || null,
            sortierung: Number(this.sortierungCtrl.value) || 0,
            aktiv: this.aktivCtrl.value ? 1 : 0,
        };
        if (this.id) {
            body.fibu_erloes_suffix_id = this.id;
        }

        this.api.post(this.apiBaseUrl + 'fibu_erloes_suffix/update.php', body).subscribe({
            next: () => {
                this.messageService.infoMessage('Erlös-Suffix gespeichert.');
                this.dialogRef.close(true);
            },
            error: err => this.messageService.errorMessage('Speichern fehlgeschlagen.', err),
        });
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
